import React from 'react';
import { SimpleUserView } from '../../../types/users';
import { UserProfileCell } from '../../../../commonv3/components/atoms/users/UserProfileCell';
import './reviewerAssignmentLabel.module.scss';

type Props = {
    id?: string;
    reviewer: SimpleUserView | null;
};
export const ReviewerAssignmentLabel = ({ id, reviewer }: Props) => {
    if (reviewer) {
        return (
            <div
                id={id}
                styleName="reviewer-assignment-status-summary assigned"
                className="reviewer-assignment-status-summary assigned"
            >
                <div styleName="reviewer-label">添削担当者</div>
                <div styleName="reviewer-profile-wrapper">
                    <UserProfileCell user={reviewer} />
                </div>
            </div>
        );
    } else {
        return (
            <div
                id={id}
                styleName="reviewer-assignment-status-summary unassigned"
                className="reviewer-assignment-status-summary unassigned"
            >
                <div styleName="reviewer-label">添削担当者</div>
                <div styleName="reviewer-profile-wrapper">担当者をアサイン中です</div>
            </div>
        );
    }
};
